export const DEFAULT_PAYMENT_DEADLINE = 10;
